import React, { useEffect, useState } from 'react'
import Header from '../include/Header'
import Sidebar from '../include/Sidebar'
import { useNavigate } from 'react-router-dom'

const Dashboard = () => {

    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    useEffect(() => {
        if (localStorage.getItem('PAY_ADMIN_TOKEN') === null) {
            navigate("/admin/login");
        }
    }, [navigate]);

    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <>
            <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
                <Header handleOpen={handleOpen} />
                <Sidebar />

                <div className="page-wrapper">
                    <div className="content container-fluid">

                        <div className="page-header">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h3 className="page-title">Welcome {localStorage.getItem('PAY_ADMIN_NAME')}!</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item active">Dashboard</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                                <div className="card dash-widget">
                                    <div className="card-body">
                                        <span className="dash-widget-icon"><i className="fa-solid fa-cubes"></i></span>
                                        <div className="dash-widget-info">
                                            <h3>112</h3>
                                            <span>Projects</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                                <div className="card dash-widget">
                                    <div className="card-body">
                                        <span className="dash-widget-icon"><i className="fa-solid fa-dollar-sign"></i></span>
                                        <div className="dash-widget-info">
                                            <h3>44</h3>
                                            <span>Clients</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                                <div className="card dash-widget">
                                    <div className="card-body">
                                        <span className="dash-widget-icon"><i className="fa-regular fa-gem"></i></span>
                                        <div className="dash-widget-info">
                                            <h3>37</h3>
                                            <span>Tasks</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                                <div className="card dash-widget">
                                    <div className="card-body">
                                        <span className="dash-widget-icon"><i className="fa-solid fa-user"></i></span>
                                        <div className="dash-widget-info">
                                            <h3>218</h3>
                                            <span>Employees</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-6 text-center">
                                        <div className="card">
                                            <div className="card-body">
                                                <h3 className="card-title">Total Revenue</h3>
                                                <div id="bar-charts"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 text-center">
                                        <div className="card">
                                            <div className="card-body">
                                                <h3 className="card-title">Sales Overview</h3>
                                                <div id="line-charts"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card-group m-b-30">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between mb-3">
                                                <div>
                                                    <span className="d-block">New Employees</span>
                                                </div>
                                                <div>
                                                    <span className="text-success">+10%</span>
                                                </div>
                                            </div>
                                            <h3 className="mb-3">10</h3>
                                            <div className="progress height-five mb-2">
                                                <div className="progress-bar bg-primary w-70" role="progressbar" aria-valuenow="40"
                                                    aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                            <p className="mb-0">Overall Employees 218</p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between mb-3">
                                                <div>
                                                    <span className="d-block">Earnings</span>
                                                </div>
                                                <div>
                                                    <span className="text-success">+12.5%</span>
                                                </div>
                                            </div>
                                            <h3 className="mb-3">$1,42,300</h3>
                                            <div className="progress height-five mb-2">
                                                <div className="progress-bar bg-primary w-70" role="progressbar" aria-valuenow="40"
                                                    aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                            <p className="mb-0">Previous Month <span className="text-muted">$1,15,852</span></p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between mb-3">
                                                <div>
                                                    <span className="d-block">Expenses</span>
                                                </div>
                                                <div>
                                                    <span className="text-danger">-2.8%</span>
                                                </div>
                                            </div>
                                            <h3 className="mb-3">$8,500</h3>
                                            <div className="progress height-five mb-2">
                                                <div className="progress-bar bg-primary w-70" role="progressbar" aria-valuenow="40"
                                                    aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                            <p className="mb-0">Previous Month <span className="text-muted">$7,500</span></p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between mb-3">
                                                <div>
                                                    <span className="d-block">Profit</span>
                                                </div>
                                                <div>
                                                    <span className="text-danger">-75%</span>
                                                </div>
                                            </div>
                                            <h3 className="mb-3">$1,12,000</h3>
                                            <div className="progress height-five mb-2">
                                                <div className="progress-bar bg-primary w-70" role="progressbar" aria-valuenow="40"
                                                    aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                            <p className="mb-0">Previous Month <span className="text-muted">$1,42,000</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-xl-4 d-flex">
                                <div className="card flex-fill dash-statistics">
                                    <div className="card-body">
                                        <h5 className="card-title">Statistics</h5>
                                        <div className="stats-list">
                                            <div className="stats-info">
                                                <p>Today Leave <strong>4 <small>/ 65</small></strong></p>
                                                <div className="progress">
                                                    <div className="progress-bar bg-primary w-31" role="progressbar"
                                                        aria-valuenow="31" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                            <div className="stats-info">
                                                <p>Pending Invoice <strong>15 <small>/ 92</small></strong></p>
                                                <div className="progress">
                                                    <div className="progress-bar bg-warning w-31" role="progressbar"
                                                        aria-valuenow="31" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                            <div className="stats-info">
                                                <p>Completed Projects <strong>85 <small>/ 112</small></strong></p>
                                                <div className="progress">
                                                    <div className="progress-bar bg-success w-62" role="progressbar"
                                                        aria-valuenow="62" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                            <div className="stats-info">
                                                <p>Open Tickets <strong>190 <small>/ 212</small></strong></p>
                                                <div className="progress">
                                                    <div className="progress-bar bg-danger w-62" role="progressbar"
                                                        aria-valuenow="62" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                            <div className="stats-info">
                                                <p>Closed Tickets <strong>22 <small>/ 212</small></strong></p>
                                                <div className="progress">
                                                    <div className="progress-bar bg-info w-22" role="progressbar" aria-valuenow="22"
                                                        aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-6 col-xl-4 d-flex">
                                <div className="card flex-fill">
                                    <div className="card-body">
                                        <h4 className="card-title">Task Statistics</h4>
                                        <div className="statistics">
                                            <div className="row">
                                                <div className="col-md-6 col-6 text-center">
                                                    <div className="stats-box mb-4">
                                                        <p>Total Tasks</p>
                                                        <h3>385</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-6 text-center">
                                                    <div className="stats-box mb-4">
                                                        <p>Overdue Tasks</p>
                                                        <h3>19</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="progress mb-4">
                                            <div className="progress-bar bg-purple w-30" role="progressbar" aria-valuenow="30"
                                                aria-valuemin="0" aria-valuemax="100">30%</div>
                                            <div className="progress-bar bg-warning w-22" role="progressbar" aria-valuenow="18"
                                                aria-valuemin="0" aria-valuemax="100">22%</div>
                                            <div className="progress-bar bg-success w-24" role="progressbar" aria-valuenow="12"
                                                aria-valuemin="0" aria-valuemax="100">24%</div>
                                            <div className="progress-bar bg-danger w-21" role="progressbar" aria-valuenow="14"
                                                aria-valuemin="0" aria-valuemax="100">21%</div>
                                            <div className="progress-bar bg-info w-10" role="progressbar" aria-valuenow="14"
                                                aria-valuemin="0" aria-valuemax="100">10%</div>
                                        </div>
                                        <div>
                                            <p><i className="fa-regular fa-circle-dot text-purple me-2"></i>Completed Tasks <span
                                                className="float-end">166</span></p>
                                            <p><i className="fa-regular fa-circle-dot text-warning me-2"></i>Inprogress Tasks <span
                                                className="float-end">115</span></p>
                                            <p><i className="fa-regular fa-circle-dot text-success me-2"></i>On Hold Tasks <span
                                                className="float-end">31</span></p>
                                            <p><i className="fa-regular fa-circle-dot text-danger me-2"></i>Pending Tasks <span
                                                className="float-end">47</span></p>
                                            <p className="mb-0"><i className="fa-regular fa-circle-dot text-info me-2"></i>Review Tasks
                                                <span className="float-end">5</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-6 col-xl-4 d-flex">
                                <div className="card flex-fill">
                                    <div className="card-body">
                                        <h4 className="card-title">Today Absent <span className="badge bg-inverse-danger ms-2">5</span>
                                        </h4>
                                        <div className="leave-info-box">
                                            <div className="media d-flex align-items-center">
                                                <a href="profile.html" className="avatar"><img src="assets/img/user.jpg"
                                                    alt="User" /></a>
                                                <div className="media-body flex-grow-1">
                                                    <div className="text-sm my-0">Martin Lewis</div>
                                                </div>
                                            </div>
                                            <div className="row align-items-center mt-3">
                                                <div className="col-6">
                                                    <h6 className="mb-0">4 Sep 2019</h6>
                                                    <span className="text-sm text-muted">Leave Date</span>
                                                </div>
                                                <div className="col-6 text-end">
                                                    <span className="badge bg-inverse-danger">Pending</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="leave-info-box">
                                            <div className="media d-flex align-items-center">
                                                <a href="profile.html" className="avatar"><img src="assets/img/user.jpg"
                                                    alt="User" /></a>
                                                <div className="media-body flex-grow-1">
                                                    <div className="text-sm my-0">Martin Lewis</div>
                                                </div>
                                            </div>
                                            <div className="row align-items-center mt-3">
                                                <div className="col-6">
                                                    <h6 className="mb-0">4 Sep 2019</h6>
                                                    <span className="text-sm text-muted">Leave Date</span>
                                                </div>
                                                <div className="col-6 text-end">
                                                    <span className="badge bg-inverse-success">Approved</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="load-more text-center">
                                            {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                            <a className="text-dark" href="#">Load More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 d-flex">
                                <div className="card card-table flex-fill">
                                    <div className="card-header">
                                        <h3 className="card-title mb-0">Invoices</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table table-nowrap custom-table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Invoice ID</th>
                                                        <th>Client</th>
                                                        <th>Due Date</th>
                                                        <th>Total</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><a href="invoice-view.html">#INV-0001</a></td>
                                                        <td>
                                                            <h2><a href="#">Global Technologies</a></h2>
                                                        </td>
                                                        <td>11 Mar 2019</td>
                                                        <td>$380</td>
                                                        <td>
                                                            <span className="badge bg-inverse-warning">Partially Paid</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><a href="invoice-view.html">#INV-0002</a></td>
                                                        <td>
                                                            <h2><a href="#">Delta Infotech</a></h2>
                                                        </td>
                                                        <td>8 Feb 2019</td>
                                                        <td>$500</td>
                                                        <td>
                                                            <span className="badge bg-inverse-success">Paid</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td><a href="invoice-view.html">#INV-0003</a></td>
                                                        <td>
                                                            <h2><a href="#">Cream Inc</a></h2>
                                                        </td>
                                                        <td>23 Jan 2019</td>
                                                        <td>$60</td>
                                                        <td>
                                                            <span className="badge bg-inverse-danger">Unpaid</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <a href="invoices.html">View all invoices</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 d-flex">
                                <div className="card card-table flex-fill">
                                    <div className="card-header">
                                        <h3 className="card-title mb-0">Payments</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table custom-table table-nowrap mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Invoice ID</th>
                                                        <th>Client</th>
                                                        <th>Payment Type</th>
                                                        <th>Paid Date</th>
                                                        <th>Paid Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><a href="invoice-view.html">#INV-0001</a></td>
                                                        <td>
                                                            <h2><a href="#">Global Technologies</a></h2>
                                                        </td>
                                                        <td>Paypal</td>
                                                        <td>11 Mar 2019</td>
                                                        <td>$380</td>
                                                    </tr>
                                                    <tr>
                                                        <td><a href="invoice-view.html">#INV-0002</a></td>
                                                        <td>
                                                            <h2><a href="#">Delta Infotech</a></h2>
                                                        </td>
                                                        <td>Paypal</td>
                                                        <td>8 Feb 2019</td>
                                                        <td>$500</td>
                                                    </tr>
                                                    <tr>
                                                        <td><a href="invoice-view.html">#INV-0003</a></td>
                                                        <td>
                                                            <h2><a href="#">Cream Inc</a></h2>
                                                        </td>
                                                        <td>Paypal</td>
                                                        <td>23 Jan 2019</td>
                                                        <td>$60</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <a href="payments.html">View all payments</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </>
    )
}

export default Dashboard